export default function setKorpusHashes() {
  const isPresent = document.querySelector("[data-tab]");
  if (!isPresent) {
    return;
  }

  const triggers = document.querySelectorAll("[data-tab]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const value = trigger.href;
      const hash = value.split("#")[1];

      const korpuses = document.querySelectorAll("[data-korpus]");

      korpuses.forEach((korpus) => {
        if (korpus.href.includes("#")) {
          let currentHref = korpus.getAttribute("href");
          let newHref = currentHref.replace(/#.*/, "") + `#${hash}`;
          korpus.setAttribute("href", newHref);
        } else {
          korpus.href += `#${hash}`;
        }
      });
    });
  });

  function setHashesOnPageLoad() {
    const hash = window.location.hash;

    if (hash) {
      const korpuses = document.querySelectorAll("[data-korpus]");

      korpuses.forEach((korpus) => {
        if (korpus.href.includes("#")) {
          let currentHref = korpus.getAttribute("href");
          let newHref = currentHref.replace(/#.*/, "") + `${hash}`;
          korpus.setAttribute("href", newHref);
        } else {
          korpus.href += `${hash}`;
        }
      });
    }
  }

  setHashesOnPageLoad();
}
